// @flow
import moment from 'moment';

import {
  CONTACT_CARD_SET_ERROR,
  CONTACT_CARD_SET_FIELDS,
  CONTACT_CARD_RESET_STATE,
  CONTACT_CARD_SET_FORM_STATE,
} from 'actions/contactCard';

const INITIAL_STATE = {
  fields: {
    name: '',
    email: '',
    phone: '',
    startDate: moment(),
    endDate: moment(),
    tosAccepted: false,
    captchaResolved: false,
  },

  formState: 'initial',
};

export default function reduce(
  state = INITIAL_STATE,
  { type, fields, isError, errorMessage, errorStatus, formState }
) {
  switch (type) {
    case CONTACT_CARD_SET_ERROR:
      return {
        ...state,
        isError,
        errorMessage,
        errorStatus,
      };

    case CONTACT_CARD_SET_FIELDS:
      return {
        ...state,
        fields,
      };

    case CONTACT_CARD_SET_FORM_STATE:
      return {
        ...state,
        formState,
      };

    case CONTACT_CARD_RESET_STATE:
      return INITIAL_STATE;

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./reducers/contactCard.js